import { motion } from "framer-motion";
import { Reveal, easeLux } from "../../lib/motion";

const BIO = [
  "EverSoul was founded by Greg Demirjian, a creator and innovation strategist whose background spans creative direction, film, visual effects, music, soundscape composition, and interactive holographic presentations.",
  "That multidisciplinary experience informs EverSoul's central vision: personal memory should not be reduced to a database or chatbot. It should be preserved through responsible technology and expressed through environments that remain emotionally meaningful, visually cinematic, and fundamentally human.",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 lg:py-40 bg-[#0B0C0F] text-[#F9F8F6] overflow-hidden"
    >
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5 lg:col-start-8 lg:order-2">
          <div className="relative">
            <motion.img
              src="/founder.jpg"
              alt="Greg Demirjian, founder of EverSoul.world"
              initial={{ opacity: 0, scale: 1.06 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-10%" }}
              transition={{ duration: 1.2, ease: easeLux }}
              className="w-full max-w-md lg:max-w-none object-cover rounded-sm"
            />
            <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-white/10 rounded-sm" />
          </div>
        </Reveal>

        <div className="lg:col-span-6 lg:col-start-1 lg:order-1">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.4em] text-[#C5B498] mb-6">
              About the Founder
            </p>
            <h2 className="font-serif font-light tracking-tight leading-[1.05] text-[clamp(2rem,4vw,3.4rem)] max-w-2xl text-balance">
              Built at the intersection of story, atmosphere, identity, and emerging technology.
            </h2>
          </Reveal>

          <div className="mt-8 space-y-6">
            {BIO.map((p, i) => (
              <Reveal key={i} delay={0.08 + i * 0.06}>
                <p className="text-[#c8c9cc] text-base sm:text-lg leading-relaxed max-w-2xl">
                  {p}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.3}>
            <blockquote className="mt-10 border-l border-[#C5B498]/50 pl-6 font-serif italic text-[#e6e2d8] text-xl sm:text-2xl leading-relaxed max-w-2xl">
              Technology should not feel cold or mechanical. It should create atmosphere,
              deepen connection, inspire reflection, and open new possibilities for how people
              experience themselves and the world around them.
            </blockquote>
          </Reveal>

          <Reveal delay={0.36}>
            <div className="mt-10 border-t border-[#2A2C31] pt-6">
              <p className="text-[#F9F8F6] text-base">Founder: Greg Demirjian</p>
              <a
                href="mailto:greg@eversoul.world"
                data-testid="about-email"
                className="text-[#C5B498] hover:text-[#F9F8F6] transition-colors duration-300 text-sm"
              >
                greg@eversoul.world
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
